export default __webpack_public_path__ + "static/media/network.1a32d377.png";